







import Vue from "vue";

export default Vue.extend({
  props: {
    amount: {
      type: Number,
      required: true,
    },
  },
});
